import { TopTableBar } from "./layout/TopTableBar/TopTableBar"
import { TableAllFiles } from "./layout/TableAllFiles/TableAllFiles"
import { Uploadbar } from "components/pages/PageAllFiles/layout/Uploadbar/Uploadbar"
import { UploadbarMini } from "./layout/Uploadbar/layout/UploadbarMini/UploadbarMini"
import { useUploadbarEnabledStore, useUploadbarOpenStore } from "store/uploadFiles.store"
import style from "./PageAllFiles.module.scss"

const { PageAllFilesStyle, container } = style

export const PageAllFiles = () => {
	const { isOpen } = useUploadbarOpenStore()
	const { isEnabled } = useUploadbarEnabledStore()

	return (
		<>
			<section className={PageAllFilesStyle}>
				<div className={container}>
					<TopTableBar />
					<TableAllFiles />
				</div>
			</section>
			{isEnabled && <div>{isOpen === true ? <Uploadbar /> : <UploadbarMini />}</div>}
		</>
	)
}
